import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useVendorUsers } from "~/hooks/vendors/useVendorUsers";
import type { DealSearchCondition } from "~/models/Deal";
import type { VendorUser } from "~/models/VendorUser";
import { convertToComboBoxOption } from "~/models/VendorUser";

export function VendorUserCombobox() {
	const { data: vendorUsers } = useVendorUsers().index();
	const { setValue, control } = useFormContext<DealSearchCondition>();
	const userId = useWatch({ control, name: "userId" });

	const selectedVendorUser =
		vendorUsers?.find(({ id }) => id === userId) ?? null;

	const onVendorUserChange = useCallback(
		(option: ComponentProps<typeof SingleComboBox>["value"]) => {
			setValue("userId", option ? Number(option.value) : undefined);
		},
		[setValue]
	);
	if (vendorUsers === null) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onVendorUserChange}
			options={vendorUsers.map((vendorUser: VendorUser) =>
				convertToComboBoxOption(vendorUser)
			)}
			placeholder="担当者"
			value={
				selectedVendorUser ? convertToComboBoxOption(selectedVendorUser) : null
			}
		/>
	);
}
